import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const ArrowDown: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M16 3a1 1 0 0 1 1 1v21.59l3.3-3.3a1 1 0 0 1 1.4 1.42l-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.42l3.3 3.3V4a1 1 0 0 1 1-1Z"
    />
  </Icon>
);
